/**
 * HowToVideo — the three-minute walkthrough, self-hosted (CSP media-src
 * 'self'), narrated in the Navigator's voice. Opened from the tour's last
 * stop, the You sheet, and the onboarding intro.
 */

import { X } from 'lucide-react';
import { useHints, VIDEO_SRC, VIDEO_POSTER } from '../lib/hints';

export default function HowToVideo() {
  const h = useHints();
  if (!h?.videoOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/90 p-4" role="dialog" aria-modal="true" aria-label="How to use the Navigator">
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-between mb-2">
          <p className="text-sm font-medium text-slate-200">How to use the Navigator</p>
          <button onClick={h.closeVideo} aria-label="Close" className="text-slate-400 hover:text-slate-200 p-1"><X size={18} /></button>
        </div>
        <video
          controls
          playsInline
          autoPlay
          poster={VIDEO_POSTER}
          src={VIDEO_SRC}
          className="w-full rounded-xl border border-slate-700 bg-black max-h-[80vh]"
          onEnded={() => h.markSeen('video_watched')}
        >
          Your browser cannot play this video.
        </video>
        <p className="text-[11px] text-slate-500 mt-2 text-center">Two and a half minutes. Narrated by the Navigator.</p>
      </div>
    </div>
  );
}
